module.exports = __webpack_public_path__ + "static/media/image-slider03.89230f99.jpg";